export default __webpack_public_path__ + "static/media/pricing.d1c55a81.png";